export const ie11media = '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)'
